import gql from 'graphql-tag';

export const TemplateFavouriteStatusMutation = gql`
	mutation TemplateFavouriteStatusMutation($isFavourite: Boolean!, $templateEntityId: String!) {
		updateUserPreferences(
			userPreferences: {
				templateEntityFavouriteStatus: {
					isFavourite: $isFavourite
					templateEntityId: $templateEntityId
				}
			}
		) {
			favouriteTemplateEntityIds
		}
	}
`;
